export function unwrapNestedData<T>(body: unknown): T {
    let current: unknown = body;
    for (let depth = 0; depth < 4; depth += 1) {
        if (!current || typeof current !== 'object') {
            break;
        }
        const record = current as Record<string, unknown>;
        if (Array.isArray(record.data) || typeof record.total === 'number') {
            return current as T;
        }
        if (
            record.data &&
            typeof record.data === 'object' &&
            !Array.isArray(record.data) &&
            ('access_token' in (record.data as object) || 'id' in (record.data as object))
        ) {
            return record.data as T;
        }
        if ('data' in record) {
            current = record.data;
            continue;
        }
        break;
    }
    return current as T;
}
